import React from 'react';
import { COLOR, MARGIN } from '@latitude/core/utils/constants';
import { StyledHeading, StyledImage, StyledLink } from './Image.styled';

var Image = function Image(_ref) {
  var src = _ref.src,
      title = _ref.title,
      href = _ref.href,
      alt = _ref.alt,
      imageOnly = _ref.imageOnly;
  return !imageOnly ? /*#__PURE__*/React.createElement(StyledLink, {
    href: href,
    trackEventData: {
      label: title
    }
  }, title && /*#__PURE__*/React.createElement(StyledHeading, {
    marginBottom: MARGIN.M0,
    color: COLOR.WHITE
  }, title), /*#__PURE__*/React.createElement(StyledImage, {
    src: src,
    alt: title || alt
  })) : /*#__PURE__*/React.createElement(StyledImage, {
    src: src,
    alt: title || alt
  });
};

export default Image;